import React, { useEffect, useState } from 'react';
import { Badge, Popover, message, notification as NotifcationUI } from 'antd';
import moment from "moment-timezone";
import { useSelector, useDispatch } from 'react-redux';
// import ReactHtmlParser from 'react-html-parser';
import parse from 'html-react-parser';
import FeatherIcon from 'feather-icons-react';
import { Link, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { AtbdTopDropdwon } from './auth-info-style';
import { FetchContactDetails } from '../../../Api/Services/ContactApiService';
import { getSocket } from "../../../Api/Socket";
import { LeadDetailData } from '../../../Api/Services/LeadApiServices'
import { TaskDeatailsApi } from '../../../Api/Services/TaskapiService'
import { setEditCall, setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { FetchDealDetails } from '../../../Api/Services/DealApiService'
import { NotificationIcon, ApprovalQueueIcon, TaskIcon, LeadIcon, ContactIcon, DealIcon, AccountsIcon, ReportsIcon, CaseIcon } from '../../Icons/Icons';
// import { Popover } from '../../popup/popup';
import { QueueDetails, FetchAllApprovalMyList, FetchAllApprovalSharedList } from '../../../Api/Services/ApprovalApiService';
import { ReportDetailsAPi } from '../../../Api/Services/ReportsApiService';
import { userNotification, notificationStatus } from '../../../Api/Services/NotificationApiService';
import { useExcryptedNavigation } from '../../../container/dashboard/Filters/FilterConditions';
import Heading from '../../heading/heading';
import EditNavPopup from '../../../container/dashboard/Popup/EditNavPopup'
import ApprovePopup from '../../../container/dashboard/BusinessRulePopups/ApprovePopup'
import { FetchCaseDetails } from '../../../Api/Services/CaseApiServices';

const notificationIdsShown = new Set();

function NotificationBox() {
  const dispatch = useDispatch();
  const localData = useSelector((state) => state.localRedux);
  const defaultCurrency = localData.currency
  const ProfileData = localData.profile
  const profile = ProfileData
  const companyProfile = localData.company
  const storeSubcription = localData.subcription
  const history = useHistory();
  const edit = useSelector((state) => state.edit.edit);
  const [notification, setNotification] = useState([])
  const [isNotification, setIsNotification] = useState(false)
  const [unseenCount, setUnseenCount] = useState(0)
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const [open, setOpen] = useState(false);
  const [popupId, setPopupId] = useState()
  const [popupPage, setPopupPage] = useState()
  const [detailsId, setDetailsId] = useState()
  const [popup, setPopup] = useState(false)
  const iconWrapper = {
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: '#407fe9',
    backgroundColor: "#407fe915",
  };
  function extractTimeZoneName(tzString) {
    const parts = tzString.split(" ");
    return parts[1];
  }
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;

  const { rtl } = useSelector(state => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
    };
  });
  function renderThumb({ style, ...props }) {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: '#F1F2F6',
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }
  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      transition: 'opacity 200ms ease 0s',
      opacity: 0,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };
  function renderView({ style, ...props }) {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div {...props} style={{ ...style, ...customStyle }} />;
  }
  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };
  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };
  function highlightValuesInsideQuotes(message) {
    const regex = /"([^"]*)"/g;
    return message.replace(regex, '<span class="splTxt">$1</span>');
  }
  async function AllNotification() {
    try {
      const data = await userNotification()
      const SortedData = data.sort((a, b) => b.notificationId - a.notificationId);
      const highlightedMessages = SortedData.map(item => ({
        ...item,
        message: item.message ? highlightValuesInsideQuotes(item.message) : item.message
      }));
      setNotification(highlightedMessages.slice(0, 9));
      // const hasUnseen = highlightedMessages.slice(0, 9).some(notification => notification.status === "unseen");
      const hasUnseen = highlightedMessages.some(notification => notification.status === "unseen");
      setIsNotification(hasUnseen)
      // const count = highlightedMessages.slice(0, 9).filter(notification => notification.status === "unseen").length;
      const count = highlightedMessages.filter(notification => notification.status === "unseen").length;
      setUnseenCount(count);
    } catch (error) {
      message.error(error);
    }
  }
  useEffect(() => {
    AllNotification()
  }, []);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const handleChange = (newOpen, url) => {
    if (storeSubcription?.isActive) {
      setOpen(newOpen);
      if (edit) {
        setConfirmPopup(true)
        setLinkUrl({ type: "Normal", url })
      }
    } else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  const openApproval = (id, type, details) => {
    setDetailsId(details)
    setPopupId(id)
    setPopupPage(type)
    setPopup(true)
  }
  const { ExcryptedNavigation } = useExcryptedNavigation();
  const ViewDetailPage = (id, entity) => {
    dispatch(setReDirCall(null));
    ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
  }
  const goNaviation = async (notificationType, typeValue, notificationId, status, title) => {
    if (storeSubcription?.isActive) {
      setOpen(false);
      if (!edit) {
        if (status !== "Seen") {
          try {
            await notificationStatus({}, notificationId)
          } catch (error) {
            message.error(error)
          }
          AllNotification()
        }
      }
      if (edit) {
        let dataFound = true;
        setConfirmPopup(true)
        if (notificationType === "Task") {
          try {
            const data = await TaskDeatailsApi(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "TASK" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Lead") {
          try {
            const data = await LeadDetailData(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "LEAD" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Contact") {
          try {
            const data = await FetchContactDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "CONTACT" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Account") {
          try {
            const data = await FetchAccountDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "ACCOUNT" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Deal") {
          try {
            const data = await FetchDealDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "DEAL" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Case") {
          try {
            const data = await FetchCaseDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "CASE" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Approval Process Master" || notificationType === "Approval Process") {
          message.info("Action rejeted. you are in edit mode")
          // let dataFound = true;
          // if (
          //   title === "New Approval Request Assigned" ||
          //   title === "Approval Request Reminder" ||
          //   title === "Approval Request Overdue"
          // ) {
          //   if (FilterData1?.length) {
          //     const foundData = FilterData1?.find(item => item.approvalProcessMstId === typeValue);
          //     if (foundData) {
          //       openApproval(foundData.approvalProcessId, "Approver", foundData.approvalProcessMstId);
          //       dataFound = true;
          //     }
          //     else {
          //       dataFound = false;
          //     }
          //   }
          //   else {
          //     dataFound = false;
          //   }
          // } else if (
          //   title === "Approval Request Approved" ||
          //   title === "Approval Request Rejected"
          // ) {
          //   if (FilterData?.length) {
          //     const foundData = FilterData?.find(item => item.approvalProcessMstId === typeValue);
          //     if (foundData) {
          //       openApproval(foundData.approvalProcessId, "Requestor", foundData.approvalProcessMstId);
          //       dataFound = true;
          //     } else {
          //       dataFound = false;
          //     }
          //   }
          //   else {
          //     dataFound = false;
          //   }
          // }
          // if (!dataFound) {
          //   message.info("Approval request not found");
          // }
          // setLinkUrl("quePopup")
        }
        if (notificationType === "Report") {
          try {
            const data = await ReportDetailsAPi(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              setLinkUrl({ type: "Others", Id: typeValue, entity: "Shared" })
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
      }
      else {
        let dataFound = true;
        dispatch(setEditCall(false))
        if (notificationType === "Lead") {
          try {
            const data = await LeadDetailData(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "LEAD")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Contact") {
          try {
            const data = await FetchContactDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "CONTACT")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Account") {
          try {
            const data = await FetchAccountDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "ACCOUNT")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Deal") {
          try {
            const data = await FetchDealDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "DEAL")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Case") {
          try {
            const data = await FetchCaseDetails(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "CASE")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Task") {
          try {
            const data = await TaskDeatailsApi(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "TASK")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
        if (notificationType === "Approval Process Master" || notificationType === "Approval Process") {
          if (
            title === "New Approval Request Assigned" ||
            title === "Approval Request Reminder" ||
            title === "Approval Request Overdue"
          ) {
            try {
              const data = await QueueDetails(typeValue)
              if (!data?.allow) { dataFound = false }
              else {
                const approverData = data.data?.approvarList?.find(
                  (item) => item.approver === profile.userId
                );
                dataFound = true;
                openApproval(approverData.approvalProcessId, "Approver", data.data.approvalProcessMstId);
              }
            }
            catch (error) {
              dataFound = false;
            }
          } else if (
            title === "Approval Request Approved" ||
            title === "Approval Request Rejected"
          ) {
            try {
              const data = await QueueDetails(typeValue)
              if (!data?.allow) { dataFound = false }
              else {
                dataFound = true;
                openApproval(data.data.approval_request_id, "Requestor", data.data.approvalProcessMstId);
              }
            }
            catch (error) {
              dataFound = false;
            }
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
          // history.push(`/Home/approval-queue?${pageType}=${typeValue}`)
        }
        if (notificationType === "Report") {
          try {
            const data = await ReportDetailsAPi(typeValue)
            if (!data?.allow) { dataFound = false }
            else {
              dataFound = true;
              ViewDetailPage(typeValue, "Shared")
            }
          }
          catch (error) {
            dataFound = false;
          }
          if (!dataFound) {
            message.info("You don’t have permission to view this record. Please contact your administrator for access");
          }
        }
      }
      setOpen(false);
    } else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  }
  const convertTime = (timeStr, timeFormat) => {
    let hours;
    let minutes;
    // let seconds;
    let period;
    if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
      // Parse 12-hour time string
      const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
      hours = parseInt(timeParts[1], 10);
      minutes = parseInt(timeParts[2], 10);
      // seconds = parseInt(timeParts[3], 10);
      period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

      if (period === 'pm' && hours !== 12) {
        hours += 12;
      } else if (period === 'am' && hours === 12) {
        hours = 0;
      }
    } else {
      // Parse 24-hour time string
      const timeParts = timeStr.split(':');
      hours = parseInt(timeParts[0], 10);
      minutes = parseInt(timeParts[1], 10);
      // seconds = parseInt(timeParts[2], 10);
    }
    if (timeFormat === '12hrs' || timeFormat === '12-hour') {
      period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
    }
    // No need for an else here because we return in the if above
    if (timeFormat === '24hrs' || timeFormat === '24-hour') {
      // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }
    throw new Error('Invalid time format specified');
  };
  function convertAndFormatDateTime(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
      const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
      return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
      console.warn("Invalid timezone provided");
      return "";
    }
    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
    const dateFormat = "YYYY-MM-DD";
    const timeFormat = "24hrs";
    const formattedDate = converted.format(dateFormat);
    const rawTime = converted.format("HH:mm");
    const formattedTime = convertTime(rawTime, timeFormat);

    return `${formattedDate} ${formattedTime}`
  }
  function formatDateTime(input) {
    const date = new Date(input.replace(" ", "T"));

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return `${months[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}, ${date.getFullYear()}, ` +
      `${String(date.getHours()).padStart(2, '0')}:` +
      `${String(date.getMinutes()).padStart(2, '0')}`;
  }
  useEffect(() => {
    const socket = getSocket();
    const handleNotification = (data) => {
      const updatedNotification = {
        ...data,
        message: data.message ? highlightValuesInsideQuotes(data.message) : data.message,
      };
      setNotification(prev => [updatedNotification, ...prev].slice(0, 9));
      setUnseenCount(prev => prev + (data.status === 'unseen' ? 1 : 0));
      setIsNotification(prev => prev || data.status === 'unseen');
      if (!notificationIdsShown.has(data.notificationId)) {
        notificationIdsShown.add(data.notificationId);
        let iconElement;
        switch (updatedNotification.notificationType) {
          case "Task":
            iconElement = <TaskIcon height={22} width={22} />;
            break;
          case "Approval Process Master":
          case "Approval Process":
            iconElement = <ApprovalQueueIcon height={22} width={22} />;
            break;
          case "Lead":
            iconElement = <LeadIcon height={22} width={22} />;
            break;
          case "Contact":
            iconElement = <ContactIcon height={22} width={22} />;
            break;
          case "Account":
            iconElement = <AccountsIcon height={22} width={22} />;
            break;
          case "Deal":
            iconElement = <DealIcon height={22} width={22} />;
            break;
          case "Case":
            iconElement = <CaseIcon height={22} width={22} />;
            break;
          case "Report":
            iconElement = <ReportsIcon height={22} width={22} />;
            break;
          default:
            iconElement = <FeatherIcon icon="inbox" size={20} />;
        }
        // 🔹 Layout for the notification content
        const content = (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={iconWrapper}>{iconElement}</div>
            <div style={{
              lineHeight: 1.4,
              cursor: "pointer"
            }}>
              {/* <div style={{ fontSize: 14, color: "#333", fontWeight: 500 }}>
                You have received a new {updatedNotification.notificationType}
              </div> */}
              <div role="button" style={{ cursor: "pointer" }}
                tabIndex={0}
                onClick={() => {
                  goNaviation(updatedNotification.notificationType, updatedNotification.notificationTypeValue, updatedNotification.notificationId, updatedNotification.status, updatedNotification.notificationTittle)
                  NotifcationUI.destroy()
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    goNaviation(updatedNotification.notificationType, updatedNotification.notificationTypeValue, updatedNotification.notificationId, updatedNotification.status, updatedNotification.notificationTittle)
                  }
                }}
              // style={{
              //   color: "#2a65e8",
              //   fontWeight: 600,
              //   cursor: "pointer",
              //   marginTop: 2,
              // }}
              >
                {parse(updatedNotification.message)}
              </div>
            </div>
          </div>
        );

        // 🔹 Show the notification
        NotifcationUI.open({
          message: null,
          description: content,
          placement: "bottomRight",
          duration: 5,
          style: {
            borderRadius: 10,
            boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
            padding: "10px 14px",
            width: 360,
          },
        });
      }
    };
    socket.off("notification", handleNotification);
    socket.on("notification", handleNotification);
    const handleConnect = () => {
      socket.emit("join", profile.userId);
    };
    socket.off("connect", handleConnect);
    socket.on("connect", handleConnect);
    return () => {
      socket.off("notification", handleNotification);
      socket.off("connect", handleConnect);
    };
  }, []);
  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon nav">
      <Heading as="h5" className="atbd-top-dropdwon__title">
        <span className="title-text">Notifications</span>
        <Badge className="badge-success" count={unseenCount} />
      </Heading>
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <ul className="atbd-top-dropdwon__nav notification-list">
          {notification && notification.map((item) => {
            const convertedDate = convertAndFormatDateTime(item.createdAt, companyProfile, profile)
            const realTime = formatDateTime(convertedDate)
            const createdTime = new Date(realTime);
            const tzString = profile?.timeZone || "(GMT+0:00) UTC";
            const tz = extractTimeZoneName(tzString);
            const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
            const currentTime = new Date(currentrealTime);
            const timeDifference = Math.floor((currentTime - createdTime) / (1000 * 60)); // Difference in minutes
            // Function to format time difference
            const formatTimeDifference = () => {
              if (timeDifference < 1) {
                return 'Just now';
              }
              if (timeDifference < 60) {
                return `${timeDifference} minute${timeDifference !== 1 ? 's' : ''} ago`;
              }
              if (timeDifference < 1440) { // Less than a day
                const hours = Math.floor(timeDifference / 60);
                return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
              }
              // More than a day
              const days = Math.floor(timeDifference / 1440);
              return `${days} day${days !== 1 ? 's' : ''} ago`;
            };
            const formattedTimeDifference = formatTimeDifference();

            return (
              <li key={item.notificationId}>
                <div role="button" className='Navi-Lik-Noti'
                  tabIndex={0}
                  onClick={() => goNaviation(item.notificationType, item.notificationTypeValue, item.notificationId, item.status, item.notificationTittle)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      goNaviation(item.notificationType, item.notificationTypeValue, item.notificationId, item.status, item.notificationTittle)
                    }
                  }}
                >
                  <div className="atbd-top-dropdwon__content notifications">
                    <div className="notification-icon bg-primary">
                      {item.notificationType === "Task" ?
                        <TaskIcon height={24} width={20} />
                        :
                        (item.notificationType === "Approval Process Master" || item.notificationType === "Approval Process") ?
                          <ApprovalQueueIcon height={24} width={20} />
                          :
                          item.notificationType === "Lead" ?
                            <LeadIcon height={24} width={20} />
                            :
                            item.notificationType === "Contact" ?
                              <ContactIcon height={24} width={20} />
                              :
                              item.notificationType === "Account" ?
                                <AccountsIcon height={24} width={20} />
                                :
                                item.notificationType === "Deal" ?
                                  <DealIcon height={24} width={20} />
                                  :
                                  item.notificationType === "Case" ?
                                    <CaseIcon height={24} width={20} /> :
                                    item.notificationType === "Report" ?
                                      <ReportsIcon height={24} width={20} />
                                      :
                                      <FeatherIcon icon="inbox" />
                      }
                    </div>
                    <div className="notification-content d-flex">
                      <div className="notification-text">
                        <Heading as="h5">
                          {parse(item.message)}
                        </Heading>
                        <p>{formattedTimeDifference}</p>
                      </div>
                      <div className="notification-status">
                        <Badge dot={item.status === "unseen"} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </Scrollbars>
      <Link className="btn-seeAll" to={(storeSubcription?.isActive && !edit) ? "/Home/notifications" : combinedUrl} onClick={() => handleChange(false, "/Home/notifications")}>
        See all incoming activity
      </Link>
    </AtbdTopDropdwon>
  );
  return (
    <>
      <div className="notification" title='Notifications'>
        {edit ?
          <Badge dot={isNotification} offset={[-8, -5]}>
            <span className="head-example" style={{ cursor: "not-allowed" }}>
              <NotificationIcon height={24} width={20} />
            </span>
          </Badge>
          :
          <Popover
            placement="bottomLeft"
            content={content}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >
            <Badge dot={isNotification} offset={[-8, -5]}>
              <span className="head-example" style={{ cursor: "pointer" }}>
                <NotificationIcon height={24} width={20} />
              </span>
            </Badge>
          </Popover>}
      </div>
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={linkUrl} />}
      <ApprovePopup popup={popup} setPopup={setPopup} popupId={popupId} setPopupId={setPopupId} popupPage={popupPage} setPopupPage={setPopupPage} MyList={FetchAllApprovalMyList} SharedList={FetchAllApprovalSharedList} detailsId={detailsId}
        currencySettingsRef={defaultCurrency} type="FromNotification" />
    </>
  );
}

export default NotificationBox;